import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api/axiosInstance";
import { useNavigate } from "react-router-dom";


const FeedbackForm = () => {
  const { bootcampId } = useParams();

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [loading, setLoading] = useState(true);
const navigate = useNavigate();
  const [user, setUser] = useState({
    name: "",
    email: ""
  });

  // ✅ Load feedback questions
  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const res = await api.get(`/api/bootcamp/feedback/${bootcampId}`);
        setQuestions(res.data.questions);
      } catch (err) {
        console.error("Error loading feedback:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFeedback();
  }, [bootcampId]);

  // ✅ Handle answer change
  const handleChange = (index, value) => {
    setAnswers({
      ...answers,
      [index]: value,
    });
  };

  // ✅ Submit feedback
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.post("/api/bootcamp/feedback/submit", {
        bootcampId,
        answers,
        name: user.name,     // ✅ FIXED
        email: user.email    // ✅ FIXED
      });


      alert("Feedback submitted successfully ✅");

    navigate("/feedback-success"); 
    } catch (err) {
      console.error(err);
      alert("Failed to submit feedback ❌");
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">
        Bootcamp Feedback
      </h2>

      <form onSubmit={handleSubmit} className="grid gap-5">

        {/* ✅ USER DETAILS (ONLY ONCE) */}
        <div>
          <input
            placeholder="Your Name"
            className="border p-3 rounded w-full mb-3"
            onChange={(e) =>
              setUser({ ...user, name: e.target.value })
            }
            required
          />

          <input
            placeholder="Your Email"
            type="email"
            className="border p-3 rounded w-full"
            onChange={(e) =>
              setUser({ ...user, email: e.target.value })
            }
            required
          />
        </div>

        {/* ✅ QUESTIONS */}
        {questions.map((q, index) => {
          const questionText = typeof q === "string" ? q : q.text;
          const type = typeof q === "string" ? "text" : q.type;

          return (
            <div key={index}>
              <label className="block mb-2 font-medium">
                {questionText}
              </label>

              {/* TEXT */}
              {type === "text" && (
                <input
                  type="text"
                  className="border p-3 rounded w-full"
                  placeholder="Your answer"
                  onChange={(e) =>
                    handleChange(index, e.target.value)
                  }
                  required
                />
              )}

              {/* RATING */}
              {type === "rating" && (
                <select
                  className="border p-3 rounded w-full"
                  onChange={(e) =>
                    handleChange(index, e.target.value)
                  }
                  required
                >
                  <option value="">Select rating</option>
                  <option value="1">1 - Poor</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5 - Excellent</option>
                </select>
              )}

              {/* YES / NO */}
              {type === "yesno" && (
                <select
                  className="border p-3 rounded w-full"
                  onChange={(e) =>
                    handleChange(index, e.target.value)
                  }
                  required
                >
                  <option value="">Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              )}
            </div>
          );
        })}

        <button className="bg-blue-500 text-white py-3 rounded hover:bg-blue-600 transition">
          Submit Feedback
        </button>
      </form>
    </div>
  );
};

export default FeedbackForm;